export const CREDIT_NOTES = gql`
    query CreditNotes {
        creditNotes {
            id
            sageCreditNoteNumber
            partner {
                id
                name
                firstName
                lastName
                billingContactInformation
                primaryContactInformation
                business {
                    legalName
                }
            }
            merchant {
                id
                business {
                    legalName
                }
            }
            invoiceToType
            reason
            salesInvoice {
                id
                sageInvoiceNumber
                sageInvoiceId
            }
            totalCreditNetAmount
            totalCreditVatAmount
            totalCreditAmount
            createdAt
            updatedAt
        }
    }
`;
